import { useCallback, useEffect, useRef } from 'react';
import { sessionRevision, sessionScope } from '@/features/auth/session-scope';
import { useAuthStore } from '@/store/auth-store';

/** Workspace drafts remount for real account changes; locale/token rotation retain them. */
export function useChatViewOwner(): string {
  return useAuthStore((state) => sessionScope(state) + '|' + sessionRevision());
}

/** Fence view callbacks only. Legacy transport/cache ownership requires separate validation. */
export function useChatViewCurrent(): () => boolean {
  const revision = useRef(sessionRevision()).current;
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);
  return useCallback(() => mounted.current && revision === sessionRevision(), [revision]);
}
